import { css } from '@emotion/react';
import { semantic_colors, shapes, colors, text_styles } from '../../../foundation';

export const time_side_input_container_css = css`
  display: flex;
  flex-direction: column;
  width: 44px;
  align-self: stretch;
`;

export const time_side_input_list_css = css`
  flex: 1 0 0px;
  display: block;
  width: 44px;
  min-height: 0;
  margin: -8px 0;
  overflow: auto;
  scrollbar-width: thin;
  ::-webkit-scrollbar {
    width: 2px;
  }
  &:before,
  &:after {
    content: '';
    display: block;
    height: 8px;
  }
`;

export const time_side_input_button_css = css`
  background-color: ${semantic_colors.background.surface};
  color: ${semantic_colors.content.primary};
  display: flex;
  justify-content: center;
  align-items: center;
  list-style: none;
  width: 100%;
  cursor: pointer;
  ${shapes.border_radius.xsmall};
  transition: all 0.1s linear;
  ${text_styles.Body_12_Regular};
  padding: 6px 8px;
  text-align: center;
  border: none;
  &:hover {
    background-color: ${colors.gray10};
  }
  &:focus {
    outline: none;
    background-color: ${colors.gray10};
  }
  &:active {
    background-color: ${colors.gray20};
  }
  &[aria-selected='true'] {
    color: ${semantic_colors.accent.primary};
    background-color: ${colors.gray10};
    ${text_styles.Body_12_SemiBold};
  }
  &:disabled {
    color: ${semantic_colors.content.disabled};
    cursor: not-allowed;
    &:hover,
    &:focus {
      background-color: ${semantic_colors.background.surface};
    }
  }
`;
